import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { Trade } from '@approot/models';
import { TradesCaptureService } from '@approot/services';

@Component({
  selector: 'app-archive-trades',
  templateUrl: './archive-trades.component.html',
  styleUrls: ['./archive-trades.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArchiveTradesComponent implements OnInit {
  @Input() public tradesToArchive: Trade[] = [];
  @Output() public returnToMenu = new EventEmitter<boolean>();
  @Output() public allTradesArchivedOutput = new EventEmitter<boolean>();
  public state: '' | 'LOADING' | 'DONE' = '';
  public allTradesArchived = false;
  constructor(
    private tradesCaptureService: TradesCaptureService,
    private changeRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.archiveTrades();
  }

  public archiveTrades() {
    this.state = 'LOADING';
    this.tradesToArchive.forEach(tradeItem => {
      this.tradesCaptureService
        .getUserInfoRequest({
          task: 'archiveTrade',
          tradeId: tradeItem.tradeId
        })
        .subscribe({
          next: () => {
            this.tradesCaptureService.addRemoveLocalTrade(
              'deleteTrade',
              tradeItem.tradeId
            );
            this.tradesToArchive = this.tradesToArchive.filter(
              trade => trade.tradeId !== tradeItem.tradeId
            );
            if (!this.tradesToArchive.length) {
              this.allTradesArchived = true;
              this.allTradesArchivedOutput.emit(true);
              this.state = 'DONE';
              this.changeRef.markForCheck();
            }
          },
          error: () => {
            this.state = '';
            this.changeRef.markForCheck();
          }
        });
    });
  }

  public goBack() {
    this.returnToMenu.emit(true);
  }
}
